import { handleGetRequest } from "./http.service";

export interface LaboratoryUser {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface Laboratory {
  _id: string;
  name: string;
  email: string;
  phoneNumber: string;
  officeAddress: string;
  state: string;
  lga: string;
  about: string;
  user: LaboratoryUser;
  logo?: { url: string };
  createdAt: string;
}

export interface LaboratoriesResponse {
  page: number;
  limit: number;
  total: number;
  data: Laboratory[];
}

export const getAllLaboratories = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
}) => {
  const qs = new URLSearchParams();
  if (params?.page) qs.set("page", String(params.page));
  if (params?.limit) qs.set("limit", String(params.limit));
  if (params?.search) qs.set("search", params.search);
  const query = qs.toString() ? `?${qs}` : "";
  return handleGetRequest<LaboratoriesResponse>(`/laboratory${query}`);
};
